'use strict';

/**
 * Formatter module
 */
class Formatter {

  /**
   * cents to euro string
   * @param {integer} cents - value as euro cents
   * @param {object}  options - optional options
   * @param {integer} [options.decimals] - Number of decimals to show. Default value is calculated based on the amount of cents: even euros show 0 decimals (15 €), uneven euros show two decimals (15,10 €).
   * @param {string}  [options.decimalPoint] - Decimal point character. Default value depends on language.
   * @param {string}  [options.thousandsSeparator] - Thousands separator character. Default value depends on language.
   * @param {boolean} [options.addCurrencySymbol = true] - Add one space character and currency symbol to the end of the string
   * @param {string}  [options.currencySymbol = '€'] - override default currency symbol
   * @todo en_US formatter
   * @returns {null|string} - returns null if input value is missing or not an integer, else a formatted string.
   */
  toEuroString(cents, options = {}) {

    if (typeof cents === 'undefined' || !Number.isInteger(cents)) return null;
    const euros = cents / 100;
    const evenEuros = cents % 100 === 0;

    const defaultOptions = {
      decimals: evenEuros ? 0 : 2,
      decimalPoint: ',',
      thousandsSeparator: '',
      addCurrencySymbol: true,
      currencySymbol: '€'
    };

    const fractionDigits = evenEuros ? 0 : 2;
    // Update options
    options = Object.assign(defaultOptions, options);
    return new Intl.NumberFormat('fi-FI', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: fractionDigits
    }).format(euros);
  }
}

export default new Formatter();
